/* LOBO CUSTOM C52: barra fija "Agregar al carrito" de la ficha de producto (ver snippets/lobo-sticky-atc.liquid).
   - Se muestra cuando el botón principal ya pasó hacia arriba de la pantalla y se oculta al volver a verlo o al ver el footer.
   - No agrega nada por su cuenta: hace clic en el botón principal, así que usa la variante y la cantidad elegidas arriba y la lógica de product-form.js.
   - Copia del botón principal el estado (agotado) y del bloque de precio el precio vigente; el nombre de la variante llega con el evento "variant:change" del theme.
   - Si hay un botón flotante de WhatsApp (posición fija) en la zona de la barra, deja ese espacio libre. */
if (!customElements.get('lobo-sticky-atc')) {
  class LoboStickyAtc extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.root = document.getElementById(`shopify-section-${this.sectionId}`) || document;
      this.button = this.querySelector('[data-lobo-button]');
      this.buttonText = this.querySelector('[data-lobo-button-text]');
      this.variantEl = this.querySelector('[data-lobo-variant]');
      this.priceEl = this.querySelector('[data-lobo-price]');
      this.pastMain = false;
      this.footerVisible = false;

      this.onClick = () => {
        const main = this.mainButton();
        if (main && !main.disabled) main.click();
      };
      this.button.addEventListener('click', this.onClick);

      this.onVariantChange = (event) => {
        if (event.detail && event.detail.sectionId && String(event.detail.sectionId) !== String(this.sectionId)) return;
        const variant = event.detail && event.detail.variant;
        if (this.variantEl) {
          const title = variant && (variant.public_title || variant.title);
          this.variantEl.textContent = title && title !== 'Default Title' ? title : '';
        }
        this.observeMainButton();
        window.setTimeout(() => this.syncFromMain(), 400);
      };
      document.addEventListener('variant:change', this.onVariantChange);

      this.onResize = () => this.updateOffsets();
      window.addEventListener('resize', this.onResize, { passive: true });

      this.observeMainButton();
      this.observeFooter();
      this.observeMainChanges();
      this.syncFromMain();
      window.setTimeout(() => this.updateOffsets(), 1500);
    }

    disconnectedCallback() {
      this.button && this.button.removeEventListener('click', this.onClick);
      document.removeEventListener('variant:change', this.onVariantChange);
      window.removeEventListener('resize', this.onResize);
      this.mainObserver && this.mainObserver.disconnect();
      this.footerObserver && this.footerObserver.disconnect();
      this.changesObserver && this.changesObserver.disconnect();
    }

    mainButton() {
      return this.root.querySelector('.product-form__submit');
    }

    // El botón principal "deja de verse al bajar": no está en pantalla y quedó por encima del borde superior
    observeMainButton() {
      const main = this.mainButton();
      if (!main) return;
      if (main === this.observedMain) return;
      this.observedMain = main;
      this.mainObserver && this.mainObserver.disconnect();
      this.mainObserver = new IntersectionObserver((entries) => {
        const entry = entries[entries.length - 1];
        this.pastMain = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.render();
      });
      this.mainObserver.observe(main);
    }

    observeFooter() {
      const footer = document.querySelector('footer, .shopify-section-group-footer-group');
      if (!footer) return;
      this.footerObserver = new IntersectionObserver((entries) => {
        this.footerVisible = entries[entries.length - 1].isIntersecting;
        this.render();
      });
      this.footerObserver.observe(footer);
    }

    // Precio y estado del botón principal cambian cuando el theme actualiza la ficha (variantes): se copian aquí
    observeMainChanges() {
      const price = this.root.querySelector(`#price-${this.sectionId}`);
      const form = this.root.querySelector('product-form') || this.root;
      this.changesObserver = new MutationObserver(() => this.syncFromMain());
      if (price) this.changesObserver.observe(price, { childList: true, subtree: true, characterData: true });
      this.changesObserver.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }

    syncFromMain() {
      const main = this.mainButton();
      if (main) {
        const label = main.querySelector('span');
        if (label && this.buttonText) {
          const text = label.textContent.trim().replace(/\s+/g, ' ');
          if (text) this.buttonText.textContent = text;
        }
        this.button.disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
      }
      if (this.priceEl) {
        const mainPrice = this.root.querySelector(`#price-${this.sectionId} .price`);
        const mine = this.priceEl.querySelector('.price');
        if (mainPrice && mine && mine.outerHTML !== mainPrice.outerHTML) {
          mine.replaceWith(mainPrice.cloneNode(true));
        }
      }
    }

    render() {
      const visible = this.pastMain && !this.footerVisible;
      this.classList.toggle('is-visible', visible);
      this.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (visible) {
        this.removeAttribute('inert');
        this.updateOffsets();
      } else {
        this.setAttribute('inert', '');
      }
    }

    // Deja libre el lado donde haya un botón flotante de WhatsApp
    updateOffsets() {
      const barHeight = this.offsetHeight || 70;
      let right = 0;
      let left = 0;
      document.querySelectorAll('[class*="whatsapp" i], [id*="whatsapp" i], a[href*="wa.me"], a[href*="api.whatsapp.com"]').forEach((el) => {
        if (this.contains(el)) return;
        let node = el;
        let fixed = false;
        while (node && node !== document.body) {
          if (getComputedStyle(node).position === 'fixed') { fixed = true; break; }
          node = node.parentElement;
        }
        if (!fixed) return;
        const rect = (node || el).getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        if (rect.bottom < window.innerHeight - barHeight - 16) return;
        if (rect.left > window.innerWidth / 2) right = Math.max(right, window.innerWidth - rect.left + 12);
        else left = Math.max(left, rect.right + 12);
      });
      this.style.setProperty('--lobo-sticky-pad-right', `${Math.round(right)}px`);
      this.style.setProperty('--lobo-sticky-pad-left', `${Math.round(left)}px`);
    }
  }
  customElements.define('lobo-sticky-atc', LoboStickyAtc);
}
